import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="offer" className="bg-gradient-to-br from-coral to-coral-dark py-14 px-4 relative overflow-hidden" data-id="element-93">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-[3rem] shadow-2xl p-6 md:p-12 flex flex-col md:flex-row items-center gap-8" data-id="element-95">
          <div className="flex-1 text-center md:text-left" data-id="element-96">
            <h2 className="text-3xl md:text-5xl font-black text-dark-teal mb-4 leading-tight" data-id="element-97">
              Obtén el sistema completo hoy mismo
            </h2>
            <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-98">
              Ahorra cientos de dólares en pañales y elimina el estrés escolar
              por menos de lo que cuesta un paquete familiar de Pampers.
            </p>

            <div className="mb-6 flex flex-col items-center md:items-start" data-id="element-99">
              <span className="text-sm font-bold uppercase tracking-widest text-coral mb-2 block" data-id="element-100">
                Inversión única
              </span>
              <div className="flex items-end gap-3" data-id="element-101">
                <span className="text-3xl font-bold text-gray-400 line-through" data-id="element-102">
                  $27
                </span>
                <div className="text-7xl font-black text-dark-teal" data-id="element-103">$6.36</div>
              </div>
            </div>

            <div className="flex flex-col items-center md:items-start w-full" data-id="element-104">
              <CTAButton href="https://coresolutionsg.com/cart/47490260009147:1" external className="w-full md:w-auto text-xl py-5 px-10 shadow-coral/30" data-id="element-105">
                ¡SÍ, QUIERO LA INDEPENDENCIA DE MI HIJO AHORA!
              </CTAButton>
              <p className="text-sm text-gray-500 mt-4 text-center md:text-left" data-id="element-106">
                Haz clic para descargar tu guía PDF al instante y empezar este
                fin de semana.
              </p>
            </div>
          </div>

          <div className="w-full md:w-1/3 max-w-xs shrink-0" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/su8s666Wys2SEwhR5zaz99/Adios_Panal_en_3_Dias.png" alt="Guía Adiós Pañal en 3 Días" className="w-full rounded-2xl shadow-xl rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-108" />
          </div>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0" data-id="element-109">
        <div className="absolute top-1/4 -left-20 w-96 h-96 bg-white/20 rounded-full blur-3xl" data-id="element-110"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/20 rounded-full blur-3xl" data-id="element-111"></div>
      </div>
    </section>;
}